export let ProductModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718962081569-col-1",
                elementid: "1718962110151",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718962081569-columns",
            elementid: "1718962081569-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                colsize: "2",
                parentid: "1718962081569-col-2",
                elementid: "1718962116335",
                elementtype: "radio",
              },
            ],
            colpos: 2,
            parentid: "1718962081569-columns",
            elementid: "1718962081569-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962070420-fieldset-body",
        elementid: "1718962081569",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718962084686-col-1",
                elementid: "1718962133203",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718962084686-columns",
            elementid: "1718962084686-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718962084686-col-2",
                elementid: "1718962139100",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718962084686-columns",
            elementid: "1718962084686-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962070420-fieldset-body",
        elementid: "1718962084686",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718962087636-col-1",
                elementid: "1718962144133",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718962087636-columns",
            elementid: "1718962087636-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718962087636-col-2",
                elementid: "1692363731639",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718962087636-columns",
            elementid: "1718962087636-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962070420-fieldset-body",
        elementid: "1718962087636",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718962087636-col-2",
                elementid: "1718962149683",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1718962087636-columns",
            elementid: "1718962087636-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718962087636-col-2",
                elementid: "1720177249476",
                elementtype: "documentFile",
              },
            ],
            colpos: 2,
            parentid: "1718962087636-columns",
            elementid: "1718962087636-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962070420-fieldset-body",
        elementid: "1718962087636",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718962067510",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let SubscriptionModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718962093535-col-1",
                elementid: "1718962155999",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718962093535-columns",
            elementid: "1718962093535-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718962093535-col-2",
                elementid: "1718962162916",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1718962093535-columns",
            elementid: "1718962093535-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962074038-fieldset-body",
        elementid: "1718962093535",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              // {
              //   parentid: "1718962097604-col-1",
              //   elementid: "1718962167948",
              //   elementtype: "number",
              // },
              {
                parentid: "1718962097604-col-2",
                elementid: "1718962191832",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1718962097604-columns",
            elementid: "1718962097604-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              // {
              //   parentid: "1718962097604-col-2",
              //   elementid: "1718962191832",
              //   elementtype: "number",
              // },
              {
                parentid: "1718962211447-col-1",
                elementid: "1718962217262",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1718962097604-columns",
            elementid: "1718962097604-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962074038-fieldset-body",
        elementid: "1718962097604",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              // {
              //   parentid: "1718962211447-col-1",
              //   elementid: "1718962217262",
              //   elementtype: "number",
              // },
              {
                parentid: "1718962211447-col-2",
                elementid: "1718962222345",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1718962211447-columns",
            elementid: "1718962211447-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              // {
              //   parentid: "1718962211447-col-2",
              //   elementid: "1718962222345",
              //   elementtype: "textfield",
              // },
            ],
            colpos: 2,
            parentid: "1718962211447-columns",
            elementid: "1718962211447-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "1718962074038-fieldset-body",
        elementid: "1718962211447",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718962067510",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let UploadLayoutJSON = [
  {
    name: "New",
    child: [
      {
        parentid: "section-1720177232613-form",
        elementid: "1717412405877",
        elementtype: "documentFile",
      },
      {
        parentid: "section-1720177232613-form",
        elementid: "1717412405888",
        elementtype: "documentFile",
      },
    ],

    parentid: "myTabContent",
    elementid: "section-1720177232613",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let VariantModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718973247438-col-1",
                elementid: "1718973255355",
                elementtype: "textfield",
              },
              {
                parentid: "1718973247438-col-1",
                elementid: "1718973262354",
                elementtype: "number",
              },
              {
                parentid: "1718973247438-col-1",
                elementid: "1718973268920",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1718973247438-columns",
            elementid: "1718973247438-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718973247438-col-2",
                elementid: "1718973276453",
                elementtype: "customSelect",
              },
              {
                parentid: "1718973247438-col-2",
                elementid: "1718973281553",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1718973247438-columns",
            elementid: "1718973247438-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718973223370-form",
        elementid: "1718973247438",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718973223370",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
